import { render } from "./OptionFiltering.vue?vue&type=template&id=8f9ee59a"
import script from "./OptionFiltering.vue?vue&type=script&lang=ts"
export * from "./OptionFiltering.vue?vue&type=script&lang=ts"
script.render = render

export default script